<template>
  <b-modal :active.sync="active"
      has-modal-card full-screen :can-cancel="false">
    <div class="modal-card">
      <header class="modal-card-head">
        <div class="columns is-centered" style="width: 100%">
          <div class="column is-half">
          <p class="modal-card-title">{{ riderId ? 'Editar Jinete' : 'Ingreso Jinete'}}</p>
          </div>
        </div>
      </header>
      <section class="modal-card-body" >
        <ValidationObserver ref="observer">
        <div class="columns is-centered" style="width: 100%">
          <div class="column is-half">
            <h1 class="title is-5">Información Básica</h1>
            <b-field grouped>
              <b-field label="Primer Nombre"  label-position="inside" expanded>
                <ValidationProvider name="Primer Nombre" rules="required" v-slot="{ errors }">
                  <b-field :type="{ 'is-danger': errors[0] }" :message="errors">
                    <b-input type="text"  v-model="rider.name"  placeholder="Primer nombre de jinete"></b-input>
                  </b-field>
                </ValidationProvider>
              </b-field>
              <b-field label="Segundo nombre" label-position="inside" expanded>
                <b-input type="text" v-model="rider.second_name" placeholder="Segundo nombre de jinete"></b-input>
              </b-field>
            </b-field>
            <b-field grouped>
              <b-field label="Primer Apellido" label-position="inside" expanded>
                <ValidationProvider name="Primer Apellido" rules="required" v-slot="{ errors }">
                  <b-field :type="{ 'is-danger': errors[0] }" :message="errors">
                    <b-input type="text"  v-model="rider.lastname"  placeholder="Primer apellido de jinete"></b-input>
                  </b-field>
                </ValidationProvider>
              </b-field>
              <b-field label="Segundo Apellido" label-position="inside" expanded>
                <b-input type="text" v-model="rider.second_lastname" placeholder="Segundo apellido de jinete"></b-input>
              </b-field>
            </b-field>
            <b-field grouped>
              <b-field label="Fecha de Nacimiento" label-position="inside" expanded>
                <ValidationProvider name="Fecha de Nacimiento" rules="" v-slot="{ errors }">
                  <b-field :type="{ 'is-danger': errors[0] }" :message="errors">
                    <b-datepicker
                      v-model="birthDate"
                      :first-day-of-week="1"
                      :month-names="$moment.months()"
                      :day-names="$moment.weekdaysShort()"
                      :show-week-number="true"
                      placeholder="Click para seleccionar"
                      icon="calendar-today">
                    </b-datepicker>
                  </b-field>
                </ValidationProvider>
              </b-field>
              <b-field label="Género" label-position="inside" expanded>
                <ValidationProvider name="Género" rules="required" v-slot="{ errors }">
                  <b-field :type="{ 'is-danger': errors[0] }" :message="errors">
                    <b-select v-model="person.gender" placeholder="Seleccione un género" expanded>
                      <option v-for="option in genders" :value="option.code" :key="option.code">
                          {{ option.name }}
                      </option>
                    </b-select>
                  </b-field>
                </ValidationProvider>
              </b-field>
            </b-field>

            <h1 class="title is-5">Información de Contacto</h1>
            <b-field grouped>
              <b-field label="Dirección" label-position="inside" expanded>
                <b-input type="text" v-model="person.address" placeholder="dirección de residencia">
                </b-input>
              </b-field>
              <b-field label="Teléfono" label-position="inside" expanded>
                <b-input type="text" v-model="person.phone" placeholder="Teléfono de contacto">
                </b-input>
              </b-field>
            </b-field>

            <h1 class="title is-5">Información Cuenta</h1>
            <b-field grouped>
              <b-field label="Nombre Usuario" label-position="inside" expanded>
                <b-input type="text" v-model="rider.username" placeholder="nombre de cuenta"></b-input>
              </b-field>
              <b-field label="Email" label-position="inside" expanded>
                <ValidationProvider name="Email" :rules="`required|email|is:${confirmEmail}`" v-slot="{ errors }">
                  <b-field :type="{ 'is-danger': errors[0], 'is-success': emailAvailable }" :message="errors[0] === '{field} is not valid' ? 'El correo ya se encuentra registrado' : errors">
                    <b-input type="email" v-model="rider.email" @input="verifyEmail($event, errors[0])" placeholder="Correo electrónico"></b-input>
                  </b-field>
                </ValidationProvider>
              </b-field>
            </b-field>
            <b-field label="Activo" v-if="riderId">
              <b-switch v-model="rider.user_status_id"
                :true-value="1"
                :false-value="2"
              >
                  {{rider.user_status_id === 1 ? 'Si' : 'No'}}
              </b-switch>
            </b-field>
            <b-field grouped>
              <b-field label="Cambiar contraseña" v-if="riderId">
                <b-switch v-model="changePassword">
                    {{changePassword ? 'Si' : 'No'}}
                </b-switch>
              </b-field>
              <template v-if="changePassword || !riderId">
                <b-field label="Contraseña" label-position="inside" expanded>
                  <ValidationProvider name="Contraseña" rules="required|min:8" v-slot="{ errors }">
                    <b-field :type="{ 'is-danger': errors[0] }" :message="errors">
                      <b-input type="password" v-model="rider.password" password-reveal placeholder="contraseña">
                      </b-input>
                    </b-field>
                  </ValidationProvider>
                </b-field>
                <b-field label="Repetir Contraseña" label-position="inside" expanded>
                  <ValidationProvider name="Repetir Contraseña" :rules="`required|min:8|is:${rider.password}`" v-slot="{ errors }">
                    <b-field :type="{ 'is-danger': errors[0] }" :message="errors[0] === '{field} is not valid' ? 'Las contraseñas deben ser iguales' : errors">
                      <b-input v-model="confirmPassword" type="password" password-reveal placeholder="repetir contraseña">
                      </b-input>
                    </b-field>
                  </ValidationProvider>
                </b-field>
              </template>
            </b-field>
          </div>
        </div>
        </ValidationObserver>
      </section>
      <footer class="modal-card-foot">
        <div class="columns is-centered" style="width: 100%">
          <div class="column is-half">
            <div class="columns">
              <div class="column">
                <b-button expanded @click="cancel" :disabled="isLoading">Cerrar</b-button>
              </div>
              <div class="column">
                <b-button type="is-primary" expanded @click="save" :loading="isLoading">Guardar</b-button>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import RiderService from '@/services/RiderService'
import PersonService from '@/services/PersonService'
import UserService from '@/services/UserService'

export default {
  props: {
    active: {
      type: Boolean,
      required: false,
      default: false
    },
    riderId: {
      required: false,
      default: null
    }
  },
  created () {
    if (this.riderId) {
      this.getRider()
    }
  },
  data () {
    return {
      isLoading: false,
      genders: [
        { code: 'M', name: 'Masculino' },
        { code: 'F', name: 'Femenino' }
      ],
      birthDate: null,
      confirmPassword: null,
      changePassword: false,
      oldEmail: null,
      rider: {
        name: null,
        second_name: null,
        lastname: null,
        second_lastname: null,
        username: null,
        email: null,
        user_status_id: 1
      },
      person: {
        gender: null,
        birth_date: null,
        address: null,
        phone: null
      },
      confirmEmail: null
    }
  },
  methods: {
    cancel () {
      this.$emit('update:active', false)
      this.$emit('update:riderId', null)
      this.resetForm()
    },
    resetForm () {
      this.birthDate = null
      this.confirmPassword = null
      this.changePassword = false
      this.confirmEmail = null
      this.oldEmail = null
      this.rider = {
        name: null,
        second_name: null,
        lastname: null,
        second_lastname: null,
        username: null,
        email: null,
        password: null,
        user_status_id: 1
      }
      this.person = {
        gender: null,
        birth_date: null,
        address: null,
        phone: null
      }
    },
    success (message, type) {
      this.$buefy.toast.open({
        message: message,
        type: type
      })
    },
    async getRider () {
      let params = {
        'include[0]': 'person'
      }
      let response = await RiderService.getRider(this.riderId, params)
      let rider = response.data.data
      this.rider = JSON.parse(JSON.stringify(rider))
      this.oldEmail = rider.email
      this.confirmEmail = rider.email
      this.person = rider.person ? rider.person : this.person
      this.birthDate = this.person && this.person.birth_date ? this.$moment(this.person.birth_date, 'YYYY-MM-DD').toDate() : null
    },
    async save () {
      if (await this.$refs.observer.validate()) {
        this.isLoading = true
        try {
          if (this.riderId) {
            let response = await RiderService.updateRider(this.riderId, this.rider)
            if (response && this.person.id) {
              await PersonService.updatePerson(this.riderId, this.person.id, this.person)
              this.success('Jinete editado exitosamente', 'is-success')
            } else {
              await PersonService.createPerson(this.riderId, this.person)
              this.success('Jinete editado exitosamente', 'is-success')
            }
          } else {
            let response = await RiderService.createRider(this.rider)
            if (response.data.data) {
              let user = response.data.data
              await PersonService.createPerson(user.id, this.person)
              this.success('Jinete registrado exitosamente', 'is-success')
            }
          }
        } catch (error) {
          console.log(error)
          this.success('Ha ocurrido un error', 'is-danger')
        }

        setTimeout(() => {
          this.$emit('update:active', false)
          this.$emit('saved')
          this.resetForm()
          this.isLoading = false
        }, 3000)
      }
    },
    async verifyEmail (email, errors) {
      if ((this.oldEmail !== email) && (email !== '' && email.length > 1)) {
        let response = await UserService.verifyEmail(email)
        let existEmail = response.data.exist
        if (!existEmail) {
          this.confirmEmail = email
        } else {
          this.confirmEmail = null
        }
      } else if (this.oldEmail === email) {
        this.confirmEmail = email
      } else {
        this.confirmEmail = null
      }
    }
  },
  watch: {
    birthDate (data) {
      this.person.birth_date = data ? this.$moment(data).format('YYYY-MM-DD') : null
    },
    active (data) {
      if (this.active === true && this.riderId) {
        this.getRider()
      }
    }
  },
  computed: {
    passwordConfirmStatus () {
      return this.rider.password !== this.confirmPassword && this.confirmPassword != null ? 'is-danger' : ''
    },
    passwordConfirmMessage () {
      return this.rider.password !== this.confirmPassword && this.confirmPassword != null ? ['Las contraseñas deben ser iguales'] : ''
    },
    emailAvailable () {
      return (this.confirmEmail === this.rider.email) && this.rider.email !== ''
    }
  }
}
</script>
